export default __webpack_public_path__ + "static/media/Tamarin Battle Crossbow.e0de2f88.jpg";